import React, { useContext } from "react";

import { PlayerSowStoreContext } from "@state/context/sow/PlayerSowStoreContext";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { getCurrentCulture } from "@utils";
import { Link } from "react-router-dom";
import { SowSubmissionStatusEnum } from "@data-types/sow/PlayerSowEnums";
import classnames from "classnames";

import { supportEmail } from "@utils/membership/membershipUtils";

export const SowMessageDisplay = observer(function SowMessageDisplay() {
	const playerSowStore = useContext(PlayerSowStoreContext);

	const { t } = useTranslation("contact-us");
	if (!playerSowStore?.submissionStatusMessage) {
		return null;
	}

	const iconClassName = classnames("card--empty__icon u-icon u-icon--huge", {
		"u-icon--pending":
			playerSowStore.submissionStatus ===
			SowSubmissionStatusEnum.DocumentsAlreadySubmitted,
		"u-icon--check-circle u-color--sent--success":
			playerSowStore.submissionStatus ===
			SowSubmissionStatusEnum.NoActiveSOWRequests,
		"u-icon--alert-circle u-color--sent--danger ":
			playerSowStore.submissionStatus ===
			SowSubmissionStatusEnum.ErrorFetching,
	});

	return (
		<div className="container container--empty">
			<div className="card">
				<div className="card__header">
					<div className="card--primary__title title--primary">
						{t("PLAYER_SOW.TITLE")}
					</div>
				</div>
				<div className="card__body">
					<div className="card--empty card--empty--borderless u-mar--bottom--reset">
						<div className="card--empty__content u-padd--reset">
							<i className={iconClassName} />
							<div className="card--empty__message">
								{playerSowStore.submissionStatusMessage}
								{(playerSowStore.submissionStatus ===
									SowSubmissionStatusEnum.NoActiveSOWRequests ||
									playerSowStore.submissionStatus ===
										SowSubmissionStatusEnum.ErrorFetching) && (
									<div>
										{t("contact-us:CONTACT_EMAIL")}:{" "}
										{supportEmail}
									</div>
								)}
							</div>
							{(playerSowStore.submissionStatus ===
								SowSubmissionStatusEnum.NoActiveSOWRequests ||
								playerSowStore.submissionStatus ===
									SowSubmissionStatusEnum.ErrorFetching) && (
								<Link
									to={`/${getCurrentCulture()}/support-chat`}
									className="card--empty__btn btn btn--base btn--primary--inverted btn--icon u-mar--bottom--reset u-mar--right--xsml"
									target="_blank"
								>
									<i className="u-icon u-icon--sml u-icon--support--alt" />
									{t("CHAT.SUPPORT.TITLE")}{" "}
								</Link>
							)}
							<Link
								to={`/${getCurrentCulture()}/home`}
								className="card--empty__btn btn btn--base btn--accent btn--icon"
							>
								{t("COMMON.PAGE_NOT_FOUND.BACK_TO")}{" "}
								{t("COMMON.PAGE_NOT_FOUND.HOME_PAGE")}
								<i className="u-icon u-icon--tny u-icon--arrow-right u-color--accent--text" />
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
});
